import { BaseModel, Entry, EntryTypes, Form, Resource, EntryOptions } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { DateHelper } from '../../shared/helpers/date.helper';
import { LeaResource } from '../../shared/resource/lea.resource';
import { TABLE } from '../../app.constantes';
import { Validators } from '@angular/forms';
import { disciplineFetchOptions, anneeScolaireFetchOptions } from '../../shared/resource/select-options';

const cssTextPetit = {
    group: 'col-xs-6 col-sm-6 col-md-4 col-lg-3', // col-sm-6 col-md-4 col-lg-3
    label: 'col-xs-4 ',
    input: 'col-xs-8 ',
  };

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/absence',
            methods: LeaResource.methods,
        }
    },
})
@Form({
    'table': {},
    'tableEleve': {},
    'create': {},
    'edit': {},
})
export class AbsenceModel extends BaseModel {

    @Entry({
        base: {
            hidden: true
        },
        'create': {},
        'table': {},
        'edit': {},
        'tableEleve': {},
    })
    id: string;

    @Entry({
        base: {
            hidden: true
        },
        'create': {},
        'table': {},
        'edit': {},
        'tableEleve': {},
    })
    anneeScolaire: string;

    @Entry({
        'table': {
            label: 'Elève',
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM * 2,
        }
    })
	eleveLibelle: string; // Libellé de l'élève pour l'affichage

    @Entry({
        base: {
            label: 'Date absence',
            minWidth: TABLE.MIN_WIDTH.DATE,
            transform: (value) => DateHelper.timestampToDefault(value),
            formatDisplay: 'd/M/yy',
            placeholder: 'JJ/MM/AAAA',
        },
        'tableEleve': {},
        'table': {},
        'create': {
            css: {group: 'col-xs-12'},
            type: EntryTypes.DATE,
            format: 'x',
        },
        'edit': {
            type: EntryTypes.STATIC,
            css: {group: 'col-xs-12'}
        }
    })
    dateAbsence: string;

    @Entry({
        base: {
            hidden: true
        },
        'create': {},
        'table': {},
        'tableEleve': {},
        'edit': {},
    })
    eleveId: string;

    @Entry({
        'create': {
            css: {group: 'col-xs-12'},
            type: EntryTypes.SELECT,
            label: 'Cours',
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'Le cours est obligatoire'
            },
        },
        'edit': {},
    })
    coursId: string;

    @Entry({
        base: {
            label: 'Cours',
            minWidth: TABLE.MIN_WIDTH.COURS,
        },
        'create': {},
        'table': {},
        'tableEleve': {},
        'edit': {
            type: EntryTypes.STATIC,
            label: 'Cours',
            css: {group: 'col-xs-12'}
        }
    })
    libelleCours: string; // Pour l'affichage uniquement

    @Entry({

        base: {
            label: 'Excusé',
            minWidth: TABLE.MIN_WIDTH.ID,
            transform: (value) => +value === 1 ? 'Oui' : 'Non',
        },
        'table': {},
        'tableEleve': {},
        'create': {
            css: {group: 'col-xs-12'},
            type: EntryTypes.CHECKBOX,
            label: null,
            options: [{
                label: 'Excusé',
                value: true
            }]
        },
        'edit': {
            css: {group: 'col-xs-12'},
            type: EntryTypes.CHECKBOX,
            label: null,
            options: [{
                label: 'Excusé',
                value: true
            }]
        }
    })
    isExcuse: boolean;

    @Entry({
        base: {
            label: 'Motif',
            minWidth: TABLE.MIN_WIDTH.ABSENCE_MOTIF,
        },
        'table': {},
        'tableEleve': {},
        'create': {
            css: {group: 'col-xs-12'},
            label: 'Motif',
            type: EntryTypes.TEXTAREA
        },
        'edit': {
            css: {group: 'col-xs-12'},
            label: 'Motif',
            type: EntryTypes.TEXTAREA
        }
    })
    motif: string;


    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }

        this.id = data.id;
        this.dateAbsence = data.dateAbsence;
        this.eleveId = data.eleveId;
        this.eleveLibelle = data.eleveLibelle; // Libellé de l'élève pour l'affichage
        this.coursId = data.coursId;
        this.libelleCours = data.libelleCours; // Pour l'affichage uniquement
        this.isExcuse = data.isExcuse;
        this.motif = data.motif;
        this.anneeScolaire = data.anneeScolaire;
    }


}

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/absence',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'search': {}
})

export class AbsenceSearchModel extends BaseModel {

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            label: 'Année',
            css: cssTextPetit,
            fetchOptions: anneeScolaireFetchOptions,
        }
    })
    anneeScolaire: number;

    @Entry({
        'search': {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Date absence début',
            placeholder: 'JJ-MM-AAAA',
        }
    })
    dateAbsenceDebut: string;

    @Entry({
        'search': {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Date absence fin',
            placeholder: 'JJ-MM-AAAA',
        }
    })
	dateAbsenceFin: string;

    @Entry({
        'search': {
            type: EntryTypes.SELECT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Discipline',
            fetchOptions: disciplineFetchOptions,
        }
    })
    idDiscipline: string;

    @Entry({
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Nom élève',
            placeholder: 'Nom',
        }
    })
    nomEleve: string;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            options: [{
                value: 1,
                label: 'Excusé'
            }, {
                value: 0,
                label: 'Non excusé'
            }],
        }
    })
    isExcuse: number;

    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }
        this.dateAbsenceDebut = data.dateAbsenceDebut;
        this.dateAbsenceFin = data.dateAbsenceFin;
        this.isExcuse = data.isExcuse ? data.isExcuse : -1;
        this.anneeScolaire = data.anneeScolaire;
        this.nomEleve = data.nomEleve;
        this.idDiscipline = data.idDiscipline;
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/administration/absences/absences.model.ts